module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Protected-file-971cc082ef046ef13b644e4657fbe420.svg";